import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_2 = {
  class: "W-100 D-Flex FlexWrap P-Rel",
  style: {"z-index":"500","gap":"1em"}
}
const _hoisted_3 = { class: "F-Bold M-Auto" }
const _hoisted_4 = { class: "D-Flex" }
const _hoisted_5 = {
  id: "TableToPrint",
  class: "ReportTableContainer W-100",
  style: {}
}
const _hoisted_6 = { class: "F1_5em P1_75em" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "CookiesBoxPrintInput F1_5em P1em",
  contenteditable: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesSearchInput = _resolveComponent("CookiesSearchInput")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printIT())),
        class: "Shadow2 PrintButton D-Flex RowMargin NOPRINT M-Auto",
        style: {"height":"2em"}
      }, [
        _createVNode(_component_CookiesIcon, {
          class: "V-Auto",
          style: {"width":"1.1em","height":"1.7em","margin":"0 0.3em"},
          ID: 'Printer'
        }),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Translate('Print')), 1)
      ]),
      _createVNode(_component_CookiesSearchInput, {
        Res: 'R_Exports_Search',
        Placeholder: _ctx.Translate('Search...')
      }, null, 8, ["Placeholder"]),
      _createVNode(_component_CookiesDropInputObject, {
        RowHeight: '3em',
        Name: _ctx.Translate('Customer'),
        CookiesInvalidInput: !(_ctx.MEMRead('D_Sales_Order_Customer') && _ctx.MEMRead('D_Sales_Order_Customer') !== ''),
        Options: _ctx.Customers,
        Selectors: [['Name'], ['Serial']],
        Res: 'D_Sales_Order_Customer'
      }, null, 8, ["Name", "CookiesInvalidInput", "Options"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CookiesCheckBox, {
          Type: 'Switch',
          Default: true,
          Res: 'R_Finance_Transactions_Collect',
          Name: _ctx.Translate('Collect')
        }, null, 8, ["Name"]),
        _createVNode(_component_CookiesCheckBox, {
          Type: 'Switch',
          Default: true,
          Res: 'R_Finance_Transactions_Pay',
          Name: _ctx.Translate('Pay')
        }, null, 8, ["Name"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Translate('Finance')) + " || " + _toDisplayString(_ctx.DateFormatter(_ctx.$store.state.CurrentDate.From, 'DD/MM/YYYY')) + " - " + _toDisplayString(_ctx.DateFormatter(_ctx.$store.state.CurrentDate.To, 'DD/MM/YYYY')), 1),
      _createVNode(_component_CookiesTable, {
        onOpenCustomer: _ctx.OpenVendor,
        class: "W-100",
        Loading: _ctx.Loading.length > 0,
        CookiesData: _ctx.FilteredData,
        TableSettings: _ctx.TableSettings
      }, null, 8, ["onOpenCustomer", "Loading", "CookiesData", "TableSettings"]),
      _hoisted_7
    ])
  ], 64))
}